'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import Header from '@/components/common/Header';

const HeaderWrapper = () => {
    const pathname = usePathname();
    const hiddenPaths = ['/login', '/register'];

    // Check if current path starts with any of the hidden paths
    const shouldHideHeader = hiddenPaths.some((path) => pathname === path || pathname?.startsWith(`${path}/`));

    if (shouldHideHeader) {
        return null;
    }

    return <Header />;
};

export default HeaderWrapper;
